import { Recipe } from "../models/recipe";
import { Ingredient } from "../models/ingredient";
import { MethodStep } from "../models/method-step";
import { buildShareText } from "./recipeShare";

// Escape the three characters that matter inside HTML text content, so a recipe
// like "Salt & pepper" or "Reduce by <half>" can't break the markup.
function esc(value: string): string {
  return value.replace(
    /[&<>]/g,
    (c) => (({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }) as Record<string, string>)[c],
  );
}

// Printable HTML for a recipe. Deliberately renders the SAME content as the share
// sheet (buildShareText) — one source of truth so print and share never diverge —
// wrapped in a minimal document with the text preserved via <pre>.
export function buildPrintHtml(
  recipe: Recipe,
  ingredients: Ingredient[],
  methodSteps: MethodStep[],
): string {
  const text = buildShareText(recipe, ingredients, methodSteps);
  return `<!DOCTYPE html>
<html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      body { margin: 40px; }
      pre {
        font-family: -apple-system, "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 15px; line-height: 1.5; color: #1c1917;
        white-space: pre-wrap; word-wrap: break-word; margin: 0;
      }
    </style>
  </head>
  <body><pre>${esc(text)}</pre></body>
</html>`;
}
